import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import UploadForm from '@/components/upload/UploadForm';
import { SuspendedNotice } from '@/components/ui/SuspendedNotice';
import { useBanStatus } from '@/hooks/useBanStatus';
import { EVENT_NAME, EVENT_DATE, EVENT_SUBTITLE } from '@/lib/supabase';

export default function UploadPage() {
  const { data: ban } = useBanStatus();

  return (
    <div className="min-h-screen bg-transparent">
      <header className="border-b border-border/50 bg-bg">
        <div className="container-page flex items-center justify-between py-md">
          <Link to="/" className="text-sm text-fg-soft hover:text-fg">
            <span aria-hidden>←</span> Galeria
          </Link>
          <p className="eyebrow text-xs uppercase tracking-widest text-fg-muted">
            {EVENT_NAME}
          </p>
        </div>
      </header>

      <main className="container-page flex items-center justify-center py-xl">
        {ban?.is_banned ? (
          <SuspendedNotice reason={ban.reason} />
        ) : (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className="w-full max-w-md"
          >
            <div className="mb-lg text-center">
              <p className="eyebrow text-xs uppercase tracking-widest text-fg-muted">
                {EVENT_DATE}
              </p>
              <h1 className="mt-sm font-serif text-3xl">{EVENT_NAME}</h1>
              <p className="mt-md text-sm text-fg-soft">{EVENT_SUBTITLE}</p>
            </div>
            <UploadForm eventName={EVENT_NAME} />
          </motion.div>
        )}
      </main>
    </div>
  );
}